import * as t from "io-ts"

const Device = t.type({
    type: t.string,
    systemReference: t.string,
    status: t.string,
    dataset: t.string,
})

const DeviceAlert = t.type({
    raisedAt: t.string,
    deviceSystemRef: t.string,
    description: t.string,
    alerterUsername: t.string,
    dataset: t.string,
})

export const ValidatorDevicesData = t.type({
    topAwaitingAssessmentSummary: t.array(Device),
    topLiveAlerts: t.array(DeviceAlert),
    totDevicesAwaitingAssessment: t.number,
    totDevicesNonCompliant: t.number,
    totLiveAlerts: t.number,
})

export type IValidatorDevicesData = t.TypeOf<typeof ValidatorDevicesData>
